export const buildRenderedEmailDocument = (html: string) => `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html, body {
        margin: 0;
        padding: 0;
        max-width: 100%;
        overflow-x: auto;
        background: #ffffff;
        color: #2b2b2b;
        font-family: AvenirLTPro-Medium, Helvetica, Arial, sans-serif;
        font-size: 13px;
        box-sizing: border-box;
      }

      body {
        padding: 12px;
      }

      *, *::before, *::after {
        box-sizing: border-box;
        max-width: 100% !important;
      }

      img, video, iframe {
        height: auto !important;
      }

      table {
        display: block;
        width: 100% !important;
        overflow-x: auto;
      }

      pre, code {
        white-space: pre-wrap !important;
        word-break: break-word !important;
      }

      a {
        word-break: break-word;
      }
    </style>
  </head>
  <body>${html}</body>
</html>
`;
